<template>
  <DBox
    :id="'cmp-licencing-licence_accounts-sidewindow-invoices'"
    :addButton="false"
    :addLink="false"
    :addLinkLabel="`${$t('add_new')} ${$t('invoice')}`"
  >
    <NTable
      class="dbox1"
      id="licencing-licence_accounts-sidewindow-invoices"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('invoice_date')">
            <span>{{ item["invoice_date"] }}</span>
          </td>
          <td v-bind="tdcon('invoice_no')">
            <span
              @click="onInvoiceClick(item)"
              class="ut-link ut-text-accent5"
              >{{ item["invoice_ref"] }}</span
            >
          </td>

          <td v-bind="tdcon('subject')">
            <span>{{ item["subject"] }}</span>
          </td>
          <td v-bind="tdcon('payment')">
            <div class="ut-flex">
              <div style="min-width: 20px">
                <div class="dt-checkbox v2 s1 disabled2">
                  <input
                    type="checkbox"
                    :name="'paid_flag'"
                    :id="'paid_flag'"
                    :checked="item['paid_flag'] == 1"
                    :disabled="true"
                    @click="e => onCheckBoxChange(e, item)"
                  />
                  <div class="checkmark"></div>
                </div>
              </div>
              <div style="flex: 1; margin-left: 7px">
                <span v-if="item['payment_date']">{{
                  item["payment_date"]
                }}</span>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('status')">
            <span
              class="circle"
              :style="{
                backgroundColor: `#${getInvoiceStatusColor(
                  item['color'].slice(1)
                )}`
              }"
            ></span>
            <!-- {{item['color']}} -->
          </td>
          <td v-bind="tdcon('net_amount')">
            <div style="display:flex">
              <div style="flex:0.8">{{ item["net_amount_cc"] }}</div>
              <div style="flex:0.2;min-width:10px;margin-left:5px">
                {{ item["currency_iso"] }}
              </div>
            </div>
          </td>
          <td v-bind="tdcon('EUR')">
            <span>{{item['net_amount_sys_curr']}}</span>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { productsListLDTRoutes } from "../../router/routes";
import { invoiceListLDTRoutes } from "../../../accounting/router/routes";
import { getInvoiceStatusColor } from "../../../accounting/models/color-status";

export default {
  props: {
    selectedLicenceAccountDetails: {
      type: Object
    }
  },
  components: {
    NTable,
    DBox
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      })
    };
  },
  computed: {
    Headers: function() {
      return [
        createTableHeader("invoice_date", {}),
        createTableHeader("invoice_no", {}),

        createTableHeader("subject", { f: 1.2 }),
        createTableHeader("payment", {}),
        createTableHeader("status", { mw: 50 }),
        createTableHeader("net_amount", { ta: "right" }),
        createTableHeader("EUR", {
          text: this.$store.getters.account.client.default_currency
        })
      ];
    },

    list: function() {
      return this.selectedLicenceAccountDetails.related_invoices || [];
    }
  },

  methods: {
    getInvoiceStatusColor: getInvoiceStatusColor,

    onCheckBoxChange: function(e, item) {},

    onInvoiceClick: function(item) {
      this.$router.push({
        name: invoiceListLDTRoutes.names.tab,
        params: {
          invoice_id: item.invoice_id,
          tab: "overview"
        }
      });
    }
  }
};
</script>
<style lang="scss">
.cmp-licencing-licence_accounts-sidewindow-invoices {
  // .dt-ntable {
  //   --ntable-height: 170px;
  // }
}
</style>
